// 📄 components/shared/CopyIconButton.tsx
// Botón de copiar al portapapeles con feedback visual (icono Copy → Check
// por 1.5s) — extraído del patrón que ya repetían TransactionCatalogGrid.tsx
// e InterfaceCatalogGrid.tsx (cada uno con su propio estado "copiadoId"
// atado a una lista). Acá cada botón administra su propio estado, sin
// depender de un id externo — más simple de reutilizar en cualquier lugar,
// como las filas del Panel de Discrepancias del Validador de Estructura.
import { useState } from "react";
import { Copy, Check } from "lucide-react";

interface CopyIconButtonProps {
  value: string;
  title?: string;
  className?: string;
}

export default function CopyIconButton({ value, title = "Copiar", className }: CopyIconButtonProps) {
  const [copiado, setCopiado] = useState(false);

  const handleCopiar = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 1500);
    } catch (err) {
      console.error("Error al copiar al portapapeles:", err);
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopiar}
      title={title}
      className={className || "flex-shrink-0 p-1.5 text-gray-400 hover:text-white hover:bg-white/10 rounded-lg transition-colors"}
    >
      {copiado ? <Check className="w-3.5 h-3.5 text-emerald-400" /> : <Copy className="w-3.5 h-3.5" />}
    </button>
  );
}
